import { Logo, LogoMark, ThemeToggle } from "@ml/ui";
import type { ReactNode } from "react";
import { useDocumentTitle } from "../../lib/hooks";

/**
 * Split screen for signed-out pages: the brand "stage" on the left (the one
 * place the portal gets loud), the form on the right.
 */
export function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  useDocumentTitle(title);
  return (
    <div className="gfp-auth">
      <section className="gfp-stage" aria-hidden="true">
        <div className="gfp-stage__glow gfp-stage__glow--a" />
        <div className="gfp-stage__glow gfp-stage__glow--b" />
        <div className="gfp-stage__grid" />
        <LogoMark size={640} title="" className="gfp-stage__watermark" />
        <div className="gfp-stage__inner">
          <Logo size={36} title="" />
          <div className="gfp-stage__copy">
            <h2 className="gfp-stage__headline">Give every connection a next step.</h2>
            <p className="gfp-stage__lede">
              Your relationship workspace for LinkedIn. Bring people, conversations and ideas together with Magically Linked.
            </p>
          </div>
          <p className="gfp-stage__foot">For creators, coaches and agencies who sell on LinkedIn.</p>
        </div>
      </section>
      <main className="gfp-auth__panel">
        <ThemeToggle className="gfp-auth__theme" />
        <div className="gfp-auth__mobile-logo">
          <Logo size={30} />
        </div>
        <div className="gfp-auth__card">{children}</div>
      </main>
    </div>
  );
}

export function AuthHeading({ title, lede }: { title: string; lede?: ReactNode }) {
  return (
    <header className="gfp-auth__head">
      <h1 className="gfp-auth__title">{title}</h1>
      {lede ? <p className="gfp-auth__lede">{lede}</p> : null}
    </header>
  );
}
